module.exports = __webpack_public_path__ + "img/velvetbox.d50635a0.png";